import env from "../../utils/env";
import common from "../../utils/common";

let ChecksService = function (HttpService) {
  "ngInject";

  const getDataSource = (successCb) => {
    const dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: env.getApiUrl("checks/search"),
          contentType: "application/json",
          type: "POST",
          beforeSend: _onBeforeSend,
        },
        update: {
          url: _getResourceLocation,
          contentType: "application/json",
          type: "PATCH",
          beforeSend: _onBeforeSend,
        },
        parameterMap: _parameterMap
      },
      change: successCb,
      schema: {
        data: "data",
        total: "total",
        model: {
          id: "id",
          fields: {
            "creationDate": {type: "date"},
            "dateOfBirth": {type: "date"},
            "visaExpiry": {type: "date"},
            "visaGrantDate": {type: "date"},
            "visaClass": {},
            "visaSubclass": {},
            "visaNumber": {},
            "id": {}
          }
        }
      },
      serverFiltering: true,
      serverPaging: true,
      serverSorting: true,
      pageSize: 50
    })

    return dataSource;
  }

  return { getDataSource };
}

function _getResourceLocation(options) {
  return env.getApiUrl(`checks/${options.id}`);
}

function _onBeforeSend(req) {
  var token = `Bearer ${window.localStorage.getItem("bigfootAccessToken")}`;

  req.setRequestHeader("Authorization", token);
}

function _parameterMap(data, type) {
  if (type == "read") {
    let filters = [];

    if (data.filter) filters = data.filter.filters;

    let query = Object.assign({}, { filters: filters }, data)
    delete query.filter;

    console.log("Query::", query)

    return JSON.stringify(query);
  }

  if (type == "update") {
    // Dates used in the DataSource are JavaScript Date objects.
    // Therefore convert the date to utc before sending to remove dateoffset.

    if (data.visaGrantDate)
      data.visaGrantDate = common.converToUtcDate(data.visaGrantDate);

    if (data.visaExpiry)
      data.visaExpiry = common.converToUtcDate(data.visaExpiry);

    return JSON.stringify(data);
  }
}

export default ChecksService;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/services/checks.service.js
 **/